import { Button, Modal } from "react-bootstrap";
import React, { useState, useEffect } from "react";

const ModalInsumos = (props) => {
  const { estado, onCloseModal, item, onReturnValue, isnew } = props;

  const [formData, setFormData] = useState({
    idinsumos: "",
    insumo: "",
    descripcion: "",
  });

  // 🔹 Cargar valores iniciales al abrir el modal
  useEffect(() => {
    if (item) {
      setFormData({
        idinsumos: item.idinsumos || "",
        insumo: item.insumo || "",
        descripcion: item.descripcion || "",
      });
    }
  }, [item]);

  // 🔹 Guardar
  const handleSubmit = (event) => {
    event.preventDefault();
    onReturnValue(formData, isnew);
  };

  return (
    <Modal show={estado} onHide={onCloseModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {isnew ? "Agregar Insumo" : "Editar Insumo"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit} id="insumoForm">
          {/* Campo Insumo */}
          <div className="form-group mb-3">
            <label className="form-label">
              Insumo <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              required
              value={formData.insumo}
              onChange={(e) =>
                setFormData({ ...formData, insumo: e.target.value })
              }
              placeholder="Ejemplo: Suero fisiológico"
            />
          </div>

          {/* Campo Descripción */}
          <div className="form-group mb-3">
            <label className="form-label">Descripción</label>
            <textarea
              className="form-control"
              rows={3}
              style={{ resize: "none" }}
              value={formData.descripcion}
              onChange={(e) =>
                setFormData({ ...formData, descripcion: e.target.value })
              }
              placeholder="Detalle adicional, presentación o uso del insumo..."
            ></textarea>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cancelar
        </Button>
        <Button type="submit" form="insumoForm" variant="primary">
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalInsumos;
